import { useEffect } from 'react';
import api from '../api';
import { readBrandingCache, writeBrandingCache } from '../utils/branding';

// 📌 浏览器标签页标题跟软件名(登录品牌 appName)联动。
//   index.html 的 <title> 只是首屏兜底，登录品牌加载后由这里接管：
//   - 先读 localStorage 缓存(按站点 host 拆 key，见 utils/branding.js)立即设，避免闪烁；
//   - 再异步拉 /api/settings/login-branding 用最新 appName 覆盖并回写缓存。
//   各站数据库里的 appName 不同 → 各站标题自然不同，无需再改 index.html / BRAND_TITLE。
const FALLBACK_TITLE = 'Cineart Canvas';

const applyTitle = (appName) => {
  const t = (appName || '').trim();
  if (t) document.title = t;
};

export default function useDocumentTitle() {
  useEffect(() => {
    // 1) 缓存命中：立即设标题
    const cached = readBrandingCache();
    if (cached) applyTitle(cached.appName || FALLBACK_TITLE);

    // 2) 异步拉后端最新值覆盖
    let alive = true;
    (async () => {
      try {
        const data = await api.get('/api/settings/login-branding');
        if (alive && data) {
          applyTitle(data.appName || FALLBACK_TITLE);
          writeBrandingCache(data);
        }
      } catch { /* 拉取失败保持 index.html 兜底标题 */ }
    })();

    return () => { alive = false; };
  }, []);
}
